/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

import Vue from 'vue'
import Router from 'vue-router'
// Routes
import paths from './paths'
import VueAnalytics from 'vue-analytics'
import AuthService from "../services/auth.service";
import store from "@/store/store";
import { session, storage } from "../utils/map";
import $const from "../utils/const";

// const backend_security = require("../services/security/messender_backend_jwt");
// const targetOP = process.env.VUE_APP_AUTHENTICATION_HOST;
// let el_op = document.getElementById('op-iframe');
// let iframe_url = `${process.env.VUE_APP_AUTHENTICATION_HOST}/check-session-iframe/`;
// el_op.setAttribute('src', iframe_url);
// window.addEventListener("message", receiveMessage, false);
function route(path, view, name, meta, redirect, children) {
	return {
		name: name || view,
		meta: meta,
		path,
		redirect,
		component: (resovle) => import(
			`@/views/${view}.vue`
		).then(resovle),
		children
	}
}

Vue.use(Router);
// Create a new router
const router = new Router({
	mode: 'history',
	routes: paths.map(path => route(path.path, path.view, path.name, path.meta, path.redirect, path.children)),
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		}
		if (to.hash) {
			return { selector: to.hash }
		}
		return { x: 0, y: 0 }
	}
});

if ((process.env.VUE_APP_USE_3RD_ANALYTICS || '0') == '1') {
	Vue.use(VueAnalytics, {
		id: process.env.VUE_APP_GA_ID,
		router
	})
}

let toggleBodyClass = (action, className) => {
	const el = document.body
	if (action === 'add') {
		el.classList.add(className)
	} else {
		el.classList.remove(className)
	}
}

let makeSafeForCSS = (name) => {
	return name.replace(/[^a-z0-9]/g, function (s) {
		let c = s.charCodeAt(0)
		if (c === 32) return '-'
		if (c >= 65 && c <= 90) return s.toLowerCase()
		return ('000' + c.toString(16)).slice(-4)
	})
}

router.beforeEach(async (to, from, next) => {
	// add router name to body
	if (from.name) {
		toggleBodyClass('remove', 'router-name-' + makeSafeForCSS(from.name))
	}
	if (to.name) {
		toggleBodyClass('add', 'router-name-' + makeSafeForCSS(to.name))
	}
	// eslint-disable-next-line no-unreachable
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (store.getters['auth/isLoggedIn']) {
			next()
			return
		}
		// Get provider
		const providerStr = to.query.provider ? to.query.provider : 'fpt_id'
		const provider = AuthService.getProvider(providerStr)
		storage.setItem($const.LOCAL_STORAGE_KEY.PATH_CACHE, to.path)
		storage.setItem($const.LOCAL_STORAGE_KEY.PROVIDER, JSON.stringify(provider))
		store.dispatch('auth/signIn')
		// if (!localStorage.getItem('session_state')){
		//     console.log("Don't Have Session state")
		//     window.location.href = await backend_security.get_login_url();
		// } else if (!backend_security.get_user_info()) {
		//     console.log("Don't Have Session state")
		//     window.location.href = await backend_security.get_login_url();
		// }
		// else {
		//     checkStatus();
		//     next();
		// }
	} else {
		next();
	}
});

// function checkStatus() {
//     let clientId = process.env.VUE_APP_CLIENT_ID;
//     let sessionState = localStorage.getItem('session_state');
//     let data = clientId + ' ' + sessionState;
//     document.getElementById('op-iframe').contentWindow.postMessage(data, targetOP);
// }
// async function receiveMessage(event) {
//     if (event.data === 'changed'){
//         window.location.href = await backend_security.get_login_url();
//     }
// }
export default router
